// Bump whenever the value shapes under image_<id> / imageHolder / tierImages_<id> change.
export const IMAGE_STORE_SCHEMA_VERSION = 2;

// One-off completion marker for the pre-IndexedDB localStorage -> IndexedDB import.
export const LEGACY_IMAGE_IMPORT_VERSION = 1;

export const STYLE_STORAGE_VERSION = 1;
export const TIER_STORAGE_VERSION = 1;
